<template>

	<div class="modal">

		<div class="modal-wrap">

			<div class="modal-inner">

				<h2 class="modal-title"><span v-html="title" /><span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">

					<form class="form" @submit.prevent="" v-if="fetched">

						<p v-if="ids.length===1">
							
						</p>

						<p v-if="ids.length>1">
							If you want to remove a keyword from a project, select only that keyword, deselected the project(s) and click <strong>{{buttonText}}</strong>.
						</p>

						<FormInput 
							type="checkbox" 
							v-model="projectsForKeywords" 
							:items="projectsProcessed"
							:noMarginBottom="true"
						/>

						<span class="large-button full" @click="assignProjects" v-html="buttonText" />

					</form>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import ApiService from './../../services/api.service'
import general from './../../utils/general'
import FormInput from './../Form/Input.vue'
export default {
	name: 'AssignProjects',
	components: {
		FormInput
	},
	props: {
		ids: {
			type: Array,
			default: ''
		},
		type: {
			type: String,
			default: ''
		}
	},
	data() {

		return {
			projects: [],
      		fetched: false,
			projectsForKeywords: [],
			keyword: ''
		}

	},
	computed: { 
		...mapState('general',['userLevels','projectList']),
		title () {

			if ( this.keyword !== '' ) {

				return 'Link <em>' + this.keyword + '</em> to a Project(s)';

			}

			return 'Link <em>'+this.ids.length+' Keywords</em> to Project(s)';

		},
		buttonText () {

			return 'Link To Project' + ( this.projectsForKeywords.length !== 1 ? 's' : '' );

		},
		projectsProcessed () {

			let projects = [];

			this.projectList.forEach( function (project) {

				if ( !project.active ) return;

				projects.push( { _id: project._id, label: project.name } );

			}.bind(this));

			return projects;

		},
		uri () {

			let uri;

			switch ( this.type ) {

				case 'keyword':

					uri = 'googlea/keyword-ideas';

				break;

				case 'domain':


				break;

			}

			return uri;

		}

    },
	mounted() {

		if ( this.ids.length === 1 ) {

			ApiService.get( this.uri + '/' + this.ids[0] )
				.then( function( info ) {

					general.apiResponse( info, function (info) {

						this.fetched = true;

						this.projectsForKeywords = info.projects;

						this.keyword = info.keyword;

					}.bind(this));

			}.bind(this))
			.catch( function(error) {

				Vue.set(this, 'errors', error.response.data.error);
			
			}.bind(this));

		}
		else {

			this.fetched = true;

		}

	},

	methods: {

		...mapMutations('general',['updateLoadingText']),

		assignProjects () {

			if ( this.ids.length > 1 && this.projectsForKeywords.length === 0 ) {

				this.$emit('close');
				return;

			}

			this.updateLoadingText("Updating...");

			let info = {
				_ids: this.ids,
				projects: this.projectsForKeywords
			};

			ApiService.post( this.uri + '/assign-projects', info )
				.then( function( info ) {

					this.updateLoadingText();

					general.apiResponse( info, function (info) {

						this.$emit('close',true);

					}.bind(this));

			}.bind(this))
			.catch( function(error) {

				Vue.set(this, 'errors', error.response.data.error);
				this.updateLoadingText();
			
			}.bind(this));

		},

		close() {

			this.assignProjects ();

		}

	}
}
</script>

<style lang="less" scoped>
.modal {
	.modal-inner {
		max-width: 550px;
	}
}
</style>